module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/call/noChannel-6e166149a0837c005e242f05c1d4714e.svg";